<template>
  <div class="simulators">
    <div class="homepage">
        <b-row>
            <b-col v-for="(sim, index) in simData" class="simImage" :class="sim.sim_class" :key='index' v-bind:style="{ backgroundImage: 'url(' + sim.sim_image + ')' }">
                <div class="simBlock" :class="{middle : index == '1'}">
                    <img class="simLogoImage" :src="sim.sim_logo_image">
                    <h2 class="simName">{{sim.sim_name}}</h2>
                    <h2 class="simprices">Prices from {{sim.sim_prices}}</h2>
                    <b-link :to="sim.sim_button_link" v-if="sim.sim_button !== ''" class="buttonSection">
                        <button class="EnquiryBtn">{{sim.sim_button}}</button>
                    </b-link>
                </div>
            </b-col>
        </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Sims Homepage',
  components: {

  },
  data: function() {
    return {
      acf: [],
      simData: []
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'imsim-uk' + "/wp-json/wp/v2/pages/25" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data,
            this.simData = response.data.acf.sims
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.simBlock.middle {
    margin-top: 300px;
}
::v-deep button.EnquiryBtn{
    background-color: #FD021D;
    border-color: #FD021D !important;
    border-radius: 0;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 309px;
    height: 65px;
    margin-top: 30px!important;
    margin-right: 30px;
    font-family: "noto-sans", sans-serif;
    margin-bottom: 37px;
    margin: auto;
}
button.EnquiryBtn:hover{
    background-color: #ffff;
    border-color: #ffff !important;
    border-radius: 0;
    line-height: 1;
    color: #000;
    font-size: 18px;
    font-weight: bold;
    width: 309px;
    height: 65px;
    margin-top: 30px!important;
    margin-right: 30px;
    font-family: "noto-sans", sans-serif;
    margin-bottom: 37px;
    margin: auto;
}
.simprices {
    font-size: 24px;
    font-weight: bold;
}
.simBlock {
    margin-top: 170px;
    z-index: 999;
    position: relative;
}
img.simLogoImage {
    width: 300px;
    height: 63px;
}
.simName {
    color: #FD021D;
    font-size: 30px;
    font-weight: bold;
    padding-top: 15px;
    padding-bottom: 15px;
}
.simImage {
    /* height: 500px; */
    height: 1000px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.simImage.col.overlay::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    z-index: 0;
}
img.ImageLogo.Car {
    width: 120px;
    height: auto;
    margin-top: 41px;
}
.optionAbout {
    margin: auto;
    /* margin-right: 85px */
}
.Whitetitle {
    color: #fff;
    font-size: 40px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
}
.simulators {
    /* background-color: #1A1A1A;
    padding: 50px;
    padding-top: 90px;
    padding-bottom: 90px; */
}
.WhiteStandard-text {
    font-size: 24px;
    color: #fff;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.aboutTrack-width {
    width: 70%;
    text-align: center;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 70px;
}
.borderWhite {
    border: 1px solid #FFFFFF;
}
.ImageLogo {
    height: 70px;
    width: 70px;
}
.coachingLogo {
    width: 50px;
}
.exclusive-Club {
    height: 50px;
    position: relative;
    top: 20px;
    margin-bottom: 20px;
}
.aboutBlocks {
    padding: 30px;
    height: 580px;
}
p.aboutBlock-Text {
    color: #fff;
    font-size: 20px;
    padding-top: 30px;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.triangle-right {
    width: 0;
    height: 0;
    border-top: 60px solid transparent;
    border-left: 61px solid #D80E1F;
    border-bottom: 0px solid transparent;
    transform: rotate(270deg);
    position: absolute;
    right: 16px;
    bottom: 2.1px;
}
.ImageLogoSection {
    padding-top: 40px;
    padding-bottom: 50px;
}
@media only screen and (max-width: 1366px) {
    .aboutBlocks {
        padding: 30px;
        height: 600px;
    }
}
@media only screen and (min-width: 1201px) {
    .below1200 {
        display: none;
    }
}
@media only screen and (max-width: 1200px) {
    .Whitetitle {
        color: #fff;
        font-size: 35px;
        font-family: "korolev", sans-serif;
        font-weight: 700;
        font-style: italic;
    }
    .above1200 {
        display: none;
    }
    .aboutBlocks {
        padding: 30px;
        height: 535px;
    }
    .below1200.col-lg-6 {
        margin-bottom: 30px;
    }
}
@media only screen and (max-width: 768px) {
    .simBlock.middle {
        margin-top: 150px;
        background-color: transparent;
    }
    .simBlock {
        margin-top: 170px;
        z-index: 999;
        position: relative;
        background-color: rgba(0, 0, 0, 0.5);
        padding-bottom: 20px;
        padding-top: 20px;
    }
    .simImage {
        height: 500px;
        /* height: 1000px; */
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    img.ImageLogo.Car {
        width: 120px;
        height: auto;
    }
    .triangle-right {
        bottom: 27.1px;
    }
    .borderWhite {
        margin-bottom: 25px;
    }
    .ImageLogoSection {
        padding: 0;
    }
    .aboutBlocks {
        padding: 30px;
        height: 500px;
    }
    .AboutTrackMan {
        padding: 25px;
    }
    .container {
        padding-left: 0;
        padding-right: 0;
    }
    .aboutTrack-width {
        width: 100%;
        text-align: center;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .optionAbout {
        margin: auto;
        margin-right: 0px
    }
    .Whitetitle {
        font-size: 36px;
        margin-top: 30px;
    }
    .WhiteStandard-text{
        font-size: 20px;
    }
}
</style>
